export interface AppExceptionModel {
  code?: string | undefined;
  title?: string | undefined;
  message: string;
}

export class AppException extends Error {
  constructor(public data: { code: string; message: string; details?: any }) {
    super(data.message);
    this.name = 'AppException';
  }
}
